import { useState, MouseEvent } from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ExtensionIcon from '@mui/icons-material/Extension';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import ConstructionIcon from '@mui/icons-material/Construction';

type ScaffolderToolbarActionsProps = {
  onEditorOpen?: () => void;
  onActionsOpen?: () => void;
  onRunsOpen?: () => void;
};

export const ScaffolderToolbarActions = ({
  onEditorOpen,
  onActionsOpen,
  onRunsOpen,
}: ScaffolderToolbarActionsProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (callback?: () => void) => {
    callback?.();
    handleClose();
  };

  return (
    <>
      <Tooltip title="Template Tools">
        <IconButton
          onClick={handleClick}
          sx={{ color: 'text.primary' }}
          aria-label="template tools menu"
          aria-controls={open ? 'scaffolder-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
        >
          <ConstructionIcon />
        </IconButton>
      </Tooltip>
      <Menu
        id="scaffolder-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={() => handleMenuItemClick(onEditorOpen)}>
          <ListItemIcon>
            <EditOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Editor</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleMenuItemClick(onActionsOpen)}>
          <ListItemIcon>
            <ExtensionIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Actions</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleMenuItemClick(onRunsOpen)}>
          <ListItemIcon>
            <PlayArrowIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Runs</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};
